import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

/**
 * // TODO: изменить использование на проектах на ButtonTs
 * @see https://leveltravel.atlassian.net/browse/LT-23586
 */
export const Sizes = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny',
};

export const Types = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit',
};

const SIZES = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny',
};

const TYPES = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit',
};

/**
 * @deprecated используй ButtonTs
 */

class Button extends React.PureComponent {
  render() {
    const {
      children,
      functional: isFunctional,
      primary: isPrimary,
      ...props
    } = this.props;

    let button;
    if (isFunctional) {
      button = <StyledFunctionalButton />;
    } else if (isPrimary) {
      button = <StyledPrimaryButton />;
    } else {
      button = <StyledButton />;
    }

    return React.cloneElement(button, props, children);
  }
}

Button.propTypes = {
  autoFocus: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  functional: PropTypes.bool,
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  size: PropTypes.oneOf(Object.values(SIZES)),
  type: PropTypes.oneOf(Object.values(TYPES)),
};

Button.defaultProps = {
  autoFocus: false,
  children: null,
  className: '',
  disabled: false,
  functional: false,
  onClick: Function.prototype,
  primary: false,
  size: SIZES.NORMAL,
  type: TYPES.BUTTON,
};

Button.Sizes = SIZES;
Button.Types = TYPES;

const BasePropsStyle = styled.button`
  & {
    /* CSS specificity hack. */
    cursor: pointer;
    font-family: inherit;

    ${props =>
      props.disabled &&
      `
      cursor: default;
      user-select: none;
    `}
  }
`;

const BaseStyle = styled(BasePropsStyle)`
  &:focus {
    outline: none;
  }
  border-radius: 4px;
  padding: 0 10px;

  ${props =>
    props.size &&
    props.size !== SIZES.FLEX &&
    `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `}

  ${props =>
    (props.size === SIZES.FLEX || props.size === SIZES.NORMAL) &&
    `
    line-height: 16px;
    padding-bottom: 7px;
    padding-top: 7px;
  `}
  
  ${props =>
    props.size === SIZES.FLEX &&
    `
    min-height: 43px;
    width: initial;
  `}
  
  ${props =>
    props.size === SIZES.LARGE &&
    `
    height: 48px;
    width: 150px;
  `}
  
  ${props =>
    props.size === SIZES.NORMAL &&
    `
    height: 43px;
    width: 150px;
  `}
  
  ${props =>
    props.size === SIZES.TINY &&
    `
    height: 34px;
    max-width: 150px;
  `}
`;

const StyledButton = styled(BaseStyle)`
  border: 1px solid #007aff;
  color: #007aff;

  ${props =>
    !(props.disabled || props.offHover) &&
    `
    :hover {
      border-color: #179fe3;
      color: #179fe3;
    }
  `}

  ${props =>
    props.disabled &&
    `
    border-color: #c2c5cc;
    color: #c2c5cc;
  `}
`;

const StyledPrimaryButton = styled(BaseStyle)`
  ${({ theme }) => theme.elements.button.primary};
  font-weight: 700;
  ${props =>
    props.offHover &&
    css`
      &,
      &:hover {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        border: solid 1px ${({ theme }) => theme.colors.cloudyBlue};
        background: ${({ theme }) => theme.colors.white};
      }
    `}
`;

const StyledFunctionalButton = styled(BasePropsStyle)`
  appearance: none;
  background-color: transparent;
  border: none;
  color: inherit;
  font: inherit;
`;

export default Button;
